import { render } from "./CategoryTypeNewModalPopup.vue?vue&type=template&id=3d0539bf&scoped=true"
import script from "./CategoryTypeNewModalPopup.vue?vue&type=script&lang=js"
export * from "./CategoryTypeNewModalPopup.vue?vue&type=script&lang=js"

import "./CategoryTypeNewModalPopup.vue?vue&type=style&index=0&id=3d0539bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0539bf"]])

export default __exports__